/******/ (function () {
  // webpackBootstrap
  /******/ "use strict";
  var __webpack_exports__ = {};
  // extracted by mini-css-extract-plugin


  if (document.querySelector('[data-section-type="Find Collection"]')) {
    document.querySelectorAll(`[data-section-type="Find Collection"]`).forEach(container => {
      const itemSelect = container.querySelectorAll(".item-select");
      const menuTags = container.querySelectorAll(".menu-tags");
      const mainContent = document.getElementById("MainContent");
      const overlay = container.querySelector(".bg-overlay-find-collection");
      const wrCollectionFilter = container.querySelectorAll(".wr-collection-filter a");
      let category, clan = "";

      const detailsElements = container.querySelectorAll(".wraplist details");

      detailsElements.forEach(function (detailsElement) {
        detailsElement.addEventListener("toggle", function (e) {
          e.preventDefault();
          // Nếu thẻ details được mở, đóng tất cả các thẻ details khác
          if (detailsElement.open) {
            closeAllDetailsElement(detailsElements, detailsElement);
            const searchInput = detailsElement.querySelector('.searchbar');
            searchInput.addEventListener('input', function() {
              const searchTerm = searchInput.value.toLowerCase();
              search_animal(searchTerm);
            });

            document.addEventListener('click', function (event) {
              if (!event.target.closest('.wrap-find-collection')){
                closeAllDetailsElement(detailsElements, false);
              }
            });
            overlay.classList.remove('hidden');
            
            container.style.zIndex = '15';
              container.style.position = 'relative';
          } else {
            let allClosed = true;
            detailsElements.forEach(function (otherDetails) {
              if (otherDetails.open) {
                allClosed = false;
              }
            });
            if (allClosed) {
              overlay.classList.add('hidden');
              container.style.zIndex = 'inherit';
            container.style.position = 'inherit';
            }
          }
        });
      });

      wrCollectionFilter.forEach((el) => {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          const hasActive = el.classList.contains("active");
          el.closest(".menu-tags")
            .querySelectorAll(".wr-collection-filter a")
            .forEach((el1) => {
              el1.classList.remove("active");
            });

          if (!hasActive) {
            el.classList.add("active");
          }
          const itemSelect = el.closest(".item-select");
          if(el.innerText != ""){
            itemSelect.querySelector(".placeholder-text").innerText = el.innerText;
          }

          if (itemSelect.dataset.group == "1") {
            category = el?.dataset?.slug;
          } else {
            clan = el.dataset?.slug;
          }

          el.closest("details.item-select").open = false
        });
      });

      container.querySelector(".btn-find-collection").addEventListener("click", function (e) {
        e.preventDefault();
        if (category || clan) {
          closeAllDetailsElement(detailsElements, false);
          window.open(
            `/collections/${category ? category : "all"}${clan ? "/" + clan : ""}`
          );
          const form = container.querySelector(".popup-is-open ~ form");
          const hasForm = form.classList.contains("hidden");
          if (!hasForm) {
            form.classList.add("hidden");
            mainContent.style.zIndex = "initial";
            document.querySelector('html').classList.remove("overflow-hidden");
          }
        }
      });

      container.querySelector('.popup-is-close').addEventListener("click", function (e) {
        e.preventDefault();
        const form = container.querySelector(".popup-is-open ~ form");
        const hasForm = form.classList.contains("hidden");
        if (!hasForm) {
          form.classList.add("hidden");
          mainContent.style.zIndex = "initial";
          document.querySelector('html').classList.remove("overflow-hidden");
        }
      })

      container
        .querySelector(".popup-is-open")
        .addEventListener("click", function (e) {
          e.preventDefault();
          const form = container.querySelector(".popup-is-open ~ form");
          const hasForm = form.classList.contains("hidden");
          if (hasForm) {
            form.classList.remove("hidden");
            mainContent.style.zIndex = 999999999999;
            document.querySelector('html').classList.add("overflow-hidden");
          } else {
            form.classList.add("hidden");
            mainContent.style.zIndex = "initial";
            document.querySelector('html').classList.remove("overflow-hidden");
          }
        });

      function closeAllDetailsElement(detailsElements, detailsElement){
        var allClosed = true;
        detailsElements.forEach(function (otherDetails) {
          if (otherDetails !== detailsElement && otherDetails.open) {
            allClosed = false;
            otherDetails.open = false;
          }
        });
        if (allClosed) {
          overlay.classList.add('hidden');
          container.style.zIndex = 'inherit';
          container.style.position = 'inherit';
        }
      }
    
      function search_animal(searchTerm) {
        let input = searchTerm;
        let x = document.getElementsByClassName("btn-tag-filter");
    
        for (let i = 0; i < x.length; i++) {
          if (!x[i].innerHTML.toLowerCase().includes(input)) {
            x[i].style.display = "none";
          } else {
            x[i].style.display = "inline-block";
          }
        }
      }
    });
  }

  

  /******/
})();
